import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGR = function FlagGR() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#338AF3",
    d: "M25 18.478h24.139a24.861 24.861 0 0 0-2.808-6.522H25v6.522ZM9.438 44.565h31.124a25.127 25.127 0 0 0 5.769-6.521H3.669a25.133 25.133 0 0 0 5.769 6.521ZM8.696 6.049a25.123 25.123 0 0 0-5.027 5.908h5.027V6.049ZM25 25V18.48h-9.783V25H8.696V18.48H.86A25.027 25.027 0 0 0 0 25c0 2.257.3 4.443.861 6.522H49.14c.56-2.08.861-4.265.861-6.521H25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#338AF3",
    d: "M25 0c-3.472 0-6.778.708-9.783 1.987v9.97H25V5.434h15.562A24.893 24.893 0 0 0 25 0Z"
  }));
};
FlagGR.displayName = 'FlagGR';
export default withFlagWrapper(FlagGR);
//# sourceMappingURL=index.js.map